// fetchDualCategory.ts

import { fetchListingPageDataWithPagination } from "../fetchListingPageDataWithPagination";

export async function getCourseSpeInfo(courseName: string, specialization: string): Promise<any> {
  const getQueryForCoursesSpe: Record<string, any> = {
    fields: ["course_url", "course_name"],
    populate: {
      specializations: {
        fields: ["specialization_name", "specialization_url"],
      },
    },
    publicationState: "live",
    filters: {
      course_url: {
        $eqi: courseName,
      },
      specializations: {
        specialization_url: {
          $eqi: specialization,
        },
      },
    },
  };

  try {
    const courseResponse = await fetchListingPageDataWithPagination(
      JSON.stringify(getQueryForCoursesSpe),
      getQueryForCoursesSpe,
      "courses"
    );

    const rawData = courseResponse?.results;

    if (!rawData || rawData.length === 0) {
      console.warn("No course data found.");
      return null;
    }

    const course = rawData[0]; // Extract the first matching course

    // Transform data into the required format
    const selectedSpecializations = course.specializations?.find(
      (data: any) => data.specialization_url === specialization
    );

    if (!selectedSpecializations) {
      return null;
    }

    const transformedData = {
      courseUrl: course.course_url,
      courseName: course.course_name,
      specializationName: selectedSpecializations?.specialization_name,
      specializationUrl: selectedSpecializations?.specialization_url,
    };

    return transformedData;
  } catch (error) {
    console.error("Error fetching course details:", error);
    return null;
  }
}
